import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Input,
	Form,
	Cascader,
	Upload,
	Image,
	Button,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'userInfo':{},
			
			'provinceList':[],
			'companyInfo':{},
			'fileList':[],
			'preview':{
				'visible':false,
				'src':'',
			},
			'rules':{
				'company_name':[
					{
						required: true,
						message: '请输入公司名称',
					},
				],
				'area_info':[
					{
						required: true,
						message: '请选择地区',
					},
					{
						validator: (rule,value)=>{
							if(!Array.isArray(value) || !value.length)
								return Promise.reject(new Error('请选择所在地区'));
							
							if(value.length != 3)
							{
								let find = this.state.provinceList.find(row=>{
									return row.value == value[0];
								});
								if( value.length == 1)
								{
									
									if(find.children.length)
										return Promise.reject(new Error('请选择所在城市信息'));
								}
								else if(value.length == 2)
								{
									let find1 = find.children.find(row=>{
										return row.value == value[1];
									});
									if(find1.children.length)
										return Promise.reject(new Error('请选择所在地区信息'));
								}
							}
							return Promise.resolve();
						},
					},
				],
				'address':[
					{
						required: true,
						message: '请输入详细地址',
					},
				],
				'business_license':[
					{
						required: true,
						message: '请上传营业执照',
					},
				],
			},
		};
	}
	
	componentDidMount()
	{
		this.getUserInfo();
	}
	
	getUserInfo()
	{
		let url = pcUrl('user','info');
		httpPost(url)
			.then(data=>{
				//data['is_manager'] = '0';
				this.setState({
					'userInfo':data,
				},()=>{
					this.getCompanyInfo();
				});
			});
	}
	
	getCompanyInfo()
	{
		let url = pcUrl('company','info');
		httpPost(url)
			.then(data=>{
				let companyInfo = {
					'company_name':data['company_name'],
					'area_info':[data['province_id'],data['city_id'],data['area_id']],
					'address':data['address'],
					'business_license':[{
						'uid':1,
						'name':'',
						'status':'done',
						'thumbUrl':data['business_license']['thumb_name'],
						'url':data['business_license']['image_name'],
					}],
				};
				if(!+this.state.userInfo['is_manager'])
					companyInfo['area_info'] = data['area_info'];
					
				for(let key in companyInfo)
					this.mainForm.setFieldsValue(companyInfo);
				if(!+this.state.userInfo['is_manager']) return;
					
				this.getAreaList(0)
					.then(data=>{
						data.forEach(row=>{
							row.children = [];
							row.isLeaf = false;
						});
						this.setState({
							'provinceList':data,
						});
						if(companyInfo['area_info'][0])
						{
							let provinceId = companyInfo['area_info'][0];
							this.getAreaList(provinceId)
								.then(data=>{
									data.forEach(row=>{
										row.children = [];
										row.isLeaf = false;
									});
									let provinceInfo = this.state.provinceList.find(row1=>row1.value == provinceId);
									provinceInfo.children = data;
									this.setState({
										'provinceList':[...this.state.provinceList],
									});
									
									if(companyInfo['area_info'][1])
									{
										let cityId = companyInfo['area_info'][1];
										this.getAreaList(cityId)
											.then(data=>{
												let cityInfo = provinceInfo.children.find(row2=>row2.value == cityId)
												cityInfo.children = data;
												this.setState({
													'provinceList':[...this.state.provinceList],
												});
											});
									}
								});
						}
						
					});
			});
	}
	
	loadAreaData(data)
	{
		let lastData = data[data.length - 1];
		if(lastData.children && lastData.children.length) return;
		
		lastData.loading = true;
		this.getAreaList(lastData.value)
			.then(data1=>{
				if(data1.length)
				{
					data1.forEach(row=>{
						if(data.length == 1)
						{
							row.children = [];
							row.isLeaf = false;
						}
					});
					lastData.children = data1;
				}
				else
				{
					lastData.isLeaf = true;
				}
				lastData.loading = false;
				this.setState({
					'provinceList':[...this.state.provinceList],
				});
			});
	}
	
	getAreaList(parentId)
	{
		if(!parentId) parentId = 0;
		
		let url =pcUrl('index','areaList');
		let param = {
			'parent_id':parentId,
		};
		
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					//转换data
					data = data.map(row=>{
						return {
							'label':row['area_name'],
							'value':row['area_id'],
						};
					});
					
					resolve(data);
				});
		});
	}
	
	handleRemoveImage(file)
	{
		return new Promise((resolve,reject)=>{
			confirm('确认要删除该图片吗?')
				.then(()=>{
					let url = pcUrl('user','deleteFile');
					let param = {
						'file':[
							file.thumbUrl,
							file.url,
						].join(','),
					};
					httpPost(url,param)
						.then(()=>{
							resolve();
						});
				})
				.catch(()=>{
					reject();
				});
		});
	}
	handlePreviewImage(file)
	{
		this.setState({
			'preview':{
				'visible':true,
				'src':file.url,
			},
		});
	}
	
	handleUploadChange(data)
	{
		if(data.fileList.length)
		{
			data.fileList.forEach((row,index)=>{
				if(row.response)
				{
					let response = row.response;
					if(response.code != 0)
					{
						message(response.message);
						return;
					}
					
					data.fileList[index] = {
						'uid':index+1,
						'name':'',
						'status':'done',
						'thumbUrl':response.data,
						'url':response.data.replace('thumb.',''),
					};
				}
			});
			data.fileList = data.fileList.filter(row=>{
				if(row.response && row.response.code != 0)
					return false;
				else
					return true;
			});
		}
		this.mainForm.setFieldsValue({
			'business_license':data.fileList,
		});
		/*
		if(data.file)
		{
			//if(data.file.status == 'removed')
			if(1)
			{
			}
		}
		*/
	}
	
	submit(info)
	{
		//获取地区信息
		info['province_id'] = info['area_info'][0];
		info['city_id'] = info['area_info'][1] || 0;
		info['area_id'] = info['area_info'][2] || 0;
		info['area_info'] = [];
		this.state.provinceList.some(row=>{
			if(row.value == info['province_id'])
			{
				info['area_info'].push(row.label);
				info['city_id'] && row.children.some(row1=>{
					if(row1.value == info['city_id'])
					{
						info['area_info'].push(row1.label);
						info['area_id'] && row1.children.some(row2=>{
							if(row2.value == info['area_id'])
							{
								info['area_info'].push(row2.label);
								return true;
							}
						});
						return true;
					}
				});
				return true;
			}
		});
		info['area_info'] = info['area_info'].join(' ');
		//营业执照
		info['business_license'] = info['business_license'][0]['thumbUrl'];
		
		let url = pcUrl('company','save');
		let param = info;
		httpPost(url,param)
			.then(data=>{
				message('企业资料保存成功','success');
			});
	}
	
	render()
	{
		return (
			<>
				<div className="user-panel">
					<div className="captain">
						<h3>企业资料</h3>
					</div>
					<div className="panel-body">
						<Form
							labelCol={{ span:3 }}
							initialValues={this.state.companyInfo}
							wrapperCol={{ span:10 }}
							onFinish={(data)=>this.submit(data)}
							onFinishFailed={data=>this.focusError(data)}
							ref={e=>this.mainForm = e}>
							<Form.Item name="company_name" label="公司名称" rules={this.state.rules['company_name']}>
								{+this.state.userInfo['is_manager']?(
									<Input />
								):(
									<span>{this.mainForm && this.mainForm.getFieldValue('company_name')}</span>
								)}
							</Form.Item>
							<Form.Item name="area_info" label="所在地区" rules={this.state.rules['area_info']}>
								{+this.state.userInfo['is_manager']?(
									<Cascader options={this.state.provinceList} loadData={e=>this.loadAreaData(e)} changeOnSelect placeholder="请选择地区" />
								):(
									<span>{this.mainForm && this.mainForm.getFieldValue('area_info')}</span>
								)}
							</Form.Item>
							<Form.Item name="address" label="详细地址" rules={this.state.rules['address']}>
								{+this.state.userInfo['is_manager']?(
									<Input.TextArea rows={5}/>
								):(
									<span>{this.mainForm && this.mainForm.getFieldValue('address')}</span>
								)}
							</Form.Item>
							<Form.Item name="business_license" hidden></Form.Item>
							<Form.Item label="营业执照" shouldUpdate={(old,cur)=>old['business_license'] != cur['business_license']} rules={this.state.rules['business_license']}>
								{()=>+this.state.userInfo['is_manager'] ? (
									<>
										<Upload
											action={pcUrl('index','upload')}
											showUploadList={true}
											onRemove={file=>this.handleRemoveImage(file)}
											onChange={data=>this.handleUploadChange(data)}
											onPreview={file=>this.handlePreviewImage(file)}
											fileList={this.mainForm && this.mainForm.getFieldValue('business_license')}
											data={{'thumb_size':'500,500'}}
											listType="picture-card">
											{this.mainForm && this.mainForm.getFieldValue('business_license') && this.mainForm.getFieldValue('business_license').length == 0 ?(
												<div>
													<span style={{fontSize:'20px'}}>+</span>
													<br/>
													上传图片
												</div>
											):''}
										</Upload>
										<Image preview={{...this.state.preview,'onVisibleChange':val=>{let preview = this.state.preview; preview.visible = val; this.setState({'preview':{...preview}});}}} />
									</>
								):(
									<Image width={100} preview={{'src':this.mainForm && this.mainForm.getFieldValue('business_license') && this.mainForm.getFieldValue('business_license')[0]['url']}} src={this.mainForm && this.mainForm.getFieldValue('business_license') && this.mainForm.getFieldValue('business_license')[0]['thumbUrl']} />
								)}
							</Form.Item>
							{/*
							<Form.Item shouldUpdate label="营业执照">
								{()=>JSON.stringify(this.mainForm && this.mainForm.getFieldsValue())}
							</Form.Item>
							*/}
							{+this.state.userInfo['is_manager'] ? (
								<Form.Item wrapperCol={{ offset:3 }}>
									<Button type="primary" htmlType="submit">确认</Button>
								</Form.Item>
							):''}
						</Form>
					</div>
				</div>
			</>
		);
	}
}


